import { date } from 'quasar'
import * as Enumerable from 'linq-es2015'
import CustomerAddEditModel from './customeraddeditmodel-dialog-screen.vue';
import CustomerListModel from './customerlistmodel-list-screen.vue';


export default {
    data: function () {
        return {
            screenKey: "CustomerListModel",
            loading: false,
            actionLocked: false,
            modelId: this.$route.params.id ?? 0, // Parent Model ID
            model: { },
            
            filter: null,
            columns: [
                {
                    name: 'Id',
                    label: 'Id',
                    align: 'left',
                    field: row => row.Id,
                    sortable: false,
                    style: '',
                    
                    isVisible: () => false
                },
                {
                    name: 'Name',
                    label: 'Name',
                    align: 'left',
                    field: row => row.Name,
                    sortable: true,
                    style: '',
                    
                    isVisible: () => true
                },
                {
                    name: 'Role',
                    label: 'Role',
                    align: 'left',
                    field: row => row.Role,
                    sortable: true,
                    style: '',
                    
                    isVisible: () => true
                },
                {
                    name: 'Actions',
                    label: 'Actions',
                    align: 'center',
                    field: row => row.Actions,
                    sortable: false,
                    style: '',
                    isVisible: () => true
                },

            ],
            columnsVisible: ['Name', 'Role', 'Actions'],
            dataSource: [],
            selected: [],
            editRowKey: null,
            pagination: {
                sortBy: 'Id',
                descending: false,
                page: 1,
                rowsPerPage: 10
            },
            applicationResources: null,
            toolTipStates: {},
            localTimezoneOffset: new Date().getTimezoneOffset()
        }
    },

    methods: {
        onClearFilterActionClick() {
            this.filter = null;
        },

        async refreshScreen() {
            this.modelId = this.$route.params.id ?? 0;
            this.selected = [];

            await this.onLoadListDataSource();
        },

        onCreateActionClick() {
            if (this.actionLocked) {
                return;
            }
            this.actionLocked = true;   
                
            this.$q.dialog({
                component: CustomerAddEditModel,
                parent: this,
                index: 0,
                modelId: 0,
                modelObject: null,
                actionLabel: 'Save',
                actionTitle: 'Create',
                editMode: true
            }).onOk((payload) => {
                this.dataSource.splice(0, 0, payload.model);
            }).onDismiss(() => {
                this.actionLocked = false;
            });
        },

        onEditActionClick(rowKey, rowIndex, row) {
            if (this.actionLocked) {
                return;
            }
            this.actionLocked = true;   
                
            this.$q.dialog({
                component: CustomerAddEditModel,
                parent: this,
                index: rowIndex,
                modelId: rowKey,
                modelObject: row,
                actionLabel: 'Save',
                actionTitle: 'Edit',
                editMode: true
            }).onOk((payload) => {
                var currentItemIndex = this.dataSource.map(e => { return e.Id; }).indexOf(rowKey);
                this.dataSource.splice(currentItemIndex, 1, payload.model);
            }).onDismiss(() => {
                this.actionLocked = false;
            });
        },

        onDeleteActionClick(rowKey, rowIndex, row) {
            if (this.actionLocked) {
                return;
            }
            this.actionLocked = true;
            
            this.$q.dialog({
                title: 'Confirm',
                message: 'Are you sure?',
                cancel: true,
                persistent: true
            }).onOk(() => {
                if (this.onDeleteModelDataSource(rowKey, row)) {
                    var currentItemIndex = this.dataSource.map(e => { return e.Id; }).indexOf(rowKey);
                this.dataSource.splice(currentItemIndex, 1);
                }
            }).onDismiss(() => {
                this.actionLocked = false;
            });
        },

        async onLoadListDataSource() {
            try {
                this.loading = true;
                
                let response = await this.$http.get('/api/ui/customers/'.replace('{id}', this.modelId), {  });
                
                if (response.body.Metadata) {
                    this.model = response.body.Metadata;
                    
                    this.dataSource = response.body.Rows;
                } else {
                    this.dataSource = response.body;
                }
                
            }
            catch (ex) {
                this.$processException(ex);
            }
            finally {
                this.loading = false;
            }
        },

        async onDeleteModelDataSource(id, params) {
            try {
                this.loading = true;

                let url = this.$prepareServerUrl('/api/ui/customers/{id}', id, params);
                let response = await this.$http.delete(url, {  });
                this.$processServerJsonResponse(response.body, this.refreshScreen);
            }
            catch (ex) {
                this.$processException(ex);
            }
            finally {
                this.loading = false;
            }
        },

        
        
    },

    computed: {
        screenTitle: function () {
            return 'Customers';
        },

        
    },

    watch: {
        // Reload data if the route changed manually from browser address bar
        $route: 'refreshScreen'
    },

    mounted: async function () {
        this.refreshScreen();

    }
}